@if (!isPlaying()) {
  <button [disabled]="!sermon()" mat-icon-button color="primary" (click)="changePlay.emit(true)" class="zwi-player__button">
    <mat-icon class="player__button__icon">play_circle_filled</mat-icon>
  </button>
}
@if (isPlaying()) {
  <button mat-icon-button color="primary" (click)="changePlay.emit(false)" class="zwi-player__button">
    <mat-icon class="player__button__icon">pause_circle_filled</mat-icon>
  </button>
}
